import {
    ChatIcon,
    Flex,
    Text,
    Dialog,
    Dropdown,
    InputLabel,
    TextArea,
    CloseIcon,
} from "@fluentui/react-northstar";
import { _api_send_feedback } from "../../../api/feedback";
import useCardFeatureFeedBack from "./hooks/useCardFeatureFeedBack";
import { FeatureCard, IconWrapper } from "./index.style";

const CardFeatureFeedback = () => {
    const { dialog, ui, mutation, functions } = useCardFeatureFeedBack();

    return (
        <Dialog
            open={dialog.open}
            header="Donnez-nous votre Feedback"
            content={
                <Flex column gap="gap.small">
                    <Text
                        size="small"
                        content="Aidez-nous à améliorer l'application"
                    />
                    <Flex column>
                        <InputLabel content="Type de feedback" />
                        <Dropdown
                            items={[
                                {
                                    id: 1,
                                    header: "Général",
                                },
                                {
                                    id: 2,
                                    header: "Bug",
                                },
                                {
                                    id: 3,
                                    header: "Idée",
                                },
                            ]}
                            placeholder={"Sélectionnez un type"}
                            checkable
                            onChange={ui.handleChangeType}
                        />
                    </Flex>
                    <Flex column>
                        <InputLabel content="Message" />
                        <TextArea
                            placeholder="Décrivez votre feedback en détail..."
                            rows={6}
                            onChange={ui.handleChangeText}
                        />
                    </Flex>
                </Flex>
            }
            confirmButton={{
                content: "Envoyer",
                disabled: ui.disable_confirm_button,
                flat: true,
                loading: mutation.isLoading,
                onClick: functions.handleSubmit,
            }}
            cancelButton={{
                content: "Annuler",
                flat: true,
            }}
            headerAction={{
                icon: <CloseIcon />,
                onClick: dialog.closeDialog,
            }}
            onCancel={dialog.closeDialog}
            trigger={
                <FeatureCard onClick={dialog.openDialog}>
                    <Flex gap="gap.medium" vAlign="center">
                        <IconWrapper bgColor="#5b5fc7">
                            <ChatIcon />
                        </IconWrapper>
                        <Flex column>
                            <Text
                                weight="semibold"
                                size="large"
                                content="Laissez-nous un feedback"
                            />
                            <Text
                                content="Partagez vos commentaires et suggestions"
                                styles={{ color: "#605e5c" }}
                            />
                        </Flex>
                    </Flex>
                </FeatureCard>
            }
        />
    );
};

export default CardFeatureFeedback;
